import DatePicker from "react-datepicker";
import React, { useState } from 'react';

import firebase from '../firebase';
import { PATHNAMES } from '../utils/constants';

const FIELDS = {
    broadcastDate: 'broadcastDate',
    title: 'title'
};

function CreateBroadcastModal({ setModalOpen, setPathname, getUserBroadcasts, authUser }) {
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [broadcastDate, setBroadcastDate] = useState(null);
    const [broadcastTitle, setBroadcastTitle] = useState('');

    function handleSubmit(e) {
        e.preventDefault();
        setIsSubmitting(true);

        firebase.createBroadcast(authUser.email, broadcastTitle, broadcastDate)
            .then(async ({ broadcastId }) => {
                await getUserBroadcasts();
                const href = [PATHNAMES.broadcasts, broadcastId].join("/");
                setPathname(href);
                window.history.pushState({}, '', href);
                return setModalOpen(null);
            })
            .catch(err => alert(`Something went wrong. ${err.message || ''}`));
    }

    function onCancelClick() {
        setModalOpen(null);
    }

    function handleChange(e) {
        const { value, name } = e.target;
        switch(name) {
            case FIELDS.title:
                setBroadcastTitle(value);
                break;
        }
    }

    return (
        <div>
            <div className="full-page-overlay" onClick={onCancelClick} />
            <div className="modal-container">
                <div className="modal-container__modal edit-modal">
                    <div className="modal-title">
                        Add incoming broadcast
                    </div>
                    <div>
                        Please enter a suitable title that will help the NTS team to identify your show, eg. name of the artist.
                        <br />
                        This is for internal use only.
                    </div>
                    <form onSubmit={handleSubmit}>
                        <div className="mdl-textfield" style={{ width: '100%' }}>
                            <label className="mdl-typography--body-1" htmlFor="title">
                                Broadcast title:
                            </label>
                            <input
                                id="title"
                                required
                                className="mdl-textfield__input edit-modal__input"
                                type="text"
                                name={FIELDS.title}
                                value={broadcastTitle}
                                onChange={handleChange} />
                        </div>
                        <div className="mdl-textfield" style={{ width: '100%', paddingTop: '6px' }}>
                            <label className="mdl-typography--body-1" htmlFor={FIELDS.broadcastDate}>
                                Broadcast date:
                            </label>
                            <div>
                                <DatePicker style={{ width: '100%'}} className="mdl-textfield__input" dateFormat="yyyy/MM/dd" selected={broadcastDate} onChange={setBroadcastDate} />
                            </div>
                        </div>
                        <div className="edit-modal__buttons">
                            <button
                                className="mdl-button mdl-button--raised button-responsive"
                                name="cancel"
                                type="button"
                                onClick={onCancelClick}
                                disabled={isSubmitting}>
                                Cancel
                            </button>
                            <button
                                type="submit"
                                className="mdl-button mdl-button--raised button-blue button-responsive"
                                name="save"
                                disabled={isSubmitting}>
                                Create
                                {isSubmitting &&
                                    <i className="material-icons rotating" role="presentation">
                                        rotate_right
                                    </i>
                                }
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
}

export default CreateBroadcastModal;
